module.exports = __webpack_public_path__ + "static/media/icon-arrow-back.ba42407f.svg";